import React from 'react';
import { Box, Typography } from '@mui/material';
import { ExclamationOutlined } from '@ant-design/icons';

export function Alert({ text, color = 'warning' }) {
    const colorConfig = {
        warning: {
            bg: '#fff1e7',
            border: '#F57C00',
            icon: '#F57C00'
        },
        error: {
            bg: '#fee2e2',
            border: '#dc2626',
            icon: '#dc2626'
        },
        info: {
            bg: '#d6edff',
            border: '#0058ab',
            icon: '#0058ab'
        },
        success: {
            bg: '#d1fae5',
            border: '#059669',
            icon: '#059669'
        }
    };

    const config = colorConfig[color] || colorConfig.warning;

    return (
        <Box
            sx={{
                bgcolor: config.bg,
                border: `1px solid ${config.border}`,
                borderRadius: 1,
                p: 1.25,
                display: 'flex',
                gap: 1,
                alignItems: 'flex-start'
            }}
        >
            <Box
                sx={{
                    width: 12,
                    height: 12,
                    minWidth: 12,
                    borderRadius: '999px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: config.icon,
                    color: 'white',
                    mt: '3px',
                    fontSize: '9px',
                    '& svg': {
                        fontSize: '10px'
                    }
                }}
            >
                <ExclamationOutlined />
            </Box>
            <Typography
                sx={{
                    flex: 1,
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 400,
                    fontSize: '12px',
                    lineHeight: '17px',
                    color: '#212322'
                }}
            >
                {typeof text === 'function' ? text() : text}
            </Typography>
        </Box>
    );
}
